import { signOut } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import { useAuthStore } from '../stores/auth.js'

export const TOKEN_DURATION_HOURS = 9
export const TOKEN_FALLBACK_MS = TOKEN_DURATION_HOURS * 60 * 60 * 1000

let redirecting = false

export function isAuthError(error) {
  if (!error) return false
  const name = error.name || ''
  const msg = String(error.message || '').toLowerCase()
  return (
    name === 'NotAuthorizedException' ||
    name === 'UserUnAuthenticatedException' ||
    name === 'UserNotFoundException' ||
    name === 'InvalidParameterException' ||
    msg.includes('sesion expirada') ||
    msg.includes('sesión expirada') ||
    msg.includes('token valido') ||
    msg.includes('token válido') ||
    msg.includes('not authorized') ||
    msg.includes('unauthenticated') ||
    msg.includes('user needs to be authenticated')
  )
}

/** Limpia sesión local y lleva al login. */
export async function redirectToLogin() {
  if (redirecting) return
  redirecting = true

  try {
    const authStore = useAuthStore()
    authStore.resetAuth()

    try {
      await signOut()
    } catch {
      // La sesión de Amplify ya no existe.
    }

    const { default: router } = await import('../router/index.js')
    if (router.currentRoute.value.path !== '/auth') {
      await router.replace('/auth')
    }
  } finally {
    redirecting = false
  }
}

/** Escucha fallos de refresh de token en Amplify. */
export function initAuthSessionListener() {
  Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'tokenRefresh_failure') {
      redirectToLogin()
    }
  })
}

const SESSION_WATCHDOG_INTERVAL_MS = 60 * 1000 // chequea cada 1 minuto

/**
 * Auto-logout proactivo: antes de esto, la sesión solo se cortaba
 * "reactivamente" (cuando una llamada al API fallaba por 401, o un refresh
 * de token fallaba) - mientras tanto, el usuario podía seguir interactuando
 * con una sesión ya vencida sin enterarse, hasta que algo intentaba guardar
 * y tiraba error. Esto chequea periódicamente cuánto pasó desde el login
 * real (`authStore.loginAt`, seteado una sola vez en el login - ver
 * router/index.js, rama `comingFromAuth` - y NO en cada refresh de token) y
 * fuerza el logout a las TOKEN_DURATION_HOURS, sin esperar a que algo falle.
 *
 * Se chequea con setInterval (no un solo setTimeout) para que funcione bien
 * aunque la compu/pestaña haya estado suspendida un rato largo - cada tick
 * solo compara contra Date.now(), no depende de que el timer haya corrido
 * exactamente en hora.
 */
export function initSessionWatchdog() {
  setInterval(async () => {
    const authStore = useAuthStore()
    if (!authStore.loginAt) return
    if (Date.now() - authStore.loginAt >= TOKEN_FALLBACK_MS) {
      await redirectToLogin()
    }
  }, SESSION_WATCHDOG_INTERVAL_MS)
}
